import { motion } from "framer-motion";

const SERVICES = [
  {
    num: "01",
    title: "Stick Roofing",
    desc: "Traditional cut-and-pitch roofing built on site. Perfect for complex rooflines, extensions and renovations where off-the-shelf trusses won't fit.",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_perth-roof-carpentry/artifacts/ksiudzqh_hammersley_stickroof.jpg",
    alt: "Stick roof framing over brickwork on a Perth build",
  },
  {
    num: "02",
    title: "Roof Trusses",
    desc: "Supply and installation of engineered roof trusses. Fast to stand, precision built, and ready for the roofers without the wait.",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_perth-roof-carpentry/artifacts/jmyq5i3w_flecker_49.jpg",
    alt: "Roof trusses installed over brickwork on a Perth build",
  },
  {
    num: "03",
    title: "Timber Framing",
    desc: "Wall and structural timber framing for new builds and additions. Straight, square and true — the skeleton your project deserves.",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_perth-roof-carpentry/artifacts/1x6hg5kw_700d51a9-d03c-4179-accd-9e47138b4d3f.jpg",
    alt: "Interior timber wall and roof framing on a concrete slab",
  },
  {
    num: "04",
    title: "Roof Carpentry & Structural Timber",
    desc: "Beams, lintels, verandahs, pergolas and structural repairs. If it carries load and it's made of timber, we build it right.",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_perth-roof-carpentry/artifacts/xz9u7z13_woolcott_porch.jpg",
    alt: "Finished porch ceiling with structural post by A E Carpentry",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={reveal}
          custom={0}
          className="mb-16"
        >
          <p className="text-sm uppercase tracking-[0.3em] text-timber mb-4">What we build</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl text-white leading-[0.9]">
            Four trades.<br />
            <span className="text-outline">One crew.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 border-t border-l border-neutral-800">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.num}
              data-testid={`service-card-${s.num}`}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={reveal}
              custom={i + 1}
              className="group border-r border-b border-neutral-800 bg-surface"
            >
              <div className="overflow-hidden h-64 md:h-72">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700 ease-out"
                />
              </div>
              <div className="p-8 md:p-10">
                <span className="font-display text-timber text-lg font-bold tracking-widest">{s.num} //</span>
                <h3 className="font-display font-semibold uppercase tracking-tight text-2xl md:text-3xl text-white mt-2">
                  {s.title}
                </h3>
                <p className="text-neutral-400 text-base leading-relaxed mt-4">{s.desc}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
